import React from 'react';

export default function SectionHeading({ eyebrow, title, subtitle, center = true }) {
  return (
    <div className={`reveal ${center ? 'text-center mx-auto' : ''} max-w-2xl mb-14`}>
      {eyebrow && (
        <span className="inline-block mb-3 text-xs font-semibold tracking-[0.25em] uppercase text-[#2563eb]">
          {eyebrow}
        </span>
      )}
      <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-slate-500 text-base md:text-lg leading-relaxed">{subtitle}</p>}
    </div>
  );
}
